module.exports = __webpack_public_path__ + "img/game1.f47fe676.jpg";